import React from "react";
import bishopsEN from "../../locales/en/bishops.json";
import bishopsES from "../../locales/es/bishops.json";
import bishopsDE from "../../locales/de/bishops.json";
import bishopsSV from "../../locales/sv/bishops.json";

import { useTranslation } from "react-i18next";

const BishopPanel = () => {
  const { t, i18n } = useTranslation("labels");
  const language = i18n.language || "en";

  const bishopDataMap = {
    en: bishopsEN,
    es: bishopsES,
    de: bishopsDE,
    sv: bishopsSV,
  };

  const bishopsData = bishopDataMap[language] || bishopsEN;

  const renderBishopTile = (bishop) => (
    <div className="col-12 col-md-4 mb-4 bishop-tile" key={bishop.name}>
      <div className="text-center">
        <a href={bishop.url} target="_blank" rel="noopener noreferrer">
          <img
            className="img-fluid bishop-image"
            src={bishop.image}
            alt={bishop.name}
          />
        </a>
        <a href={bishop.url} target="_blank" rel="noopener noreferrer">
          <h5 className="bishop-name">{bishop.name}</h5>
        </a>
        <p className="bishop-desc">{bishop.desc}</p>
      </div>
    </div>
  );

  return (
    <div className="container-fluid team pb-5">
      <div className="text-center mb-4">
        <h2 className="display-4">{t("Grace")} - {t("Marian")}</h2>
        <p>{t("bishopPanelDesc")}</p>
      </div>

      <div className="container">
        <div className="row mb-3 justify-content-center">
          {bishopsData.slice(0, 1).map(renderBishopTile)}
        </div>
        <div className="row justify-content-center">
          {bishopsData.slice(1, 4).map(renderBishopTile)}
        </div>
        <div className="row justify-content-center">
          {bishopsData.slice(4, 5).map(renderBishopTile)}
        </div>
      </div>
    </div>
  );
};

export default BishopPanel;
